// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"223":"ea93cf09c1a0dad581a134862787918d","847":"e91cc095c88d7442c9ef7eff7dbf048e"}[chunkId] + ".js";
};